import _ from 'lodash';

export function productDescription(product: any): string {
  if (product) {
    let returnedDescription = product.productLine || '';
    switch (product.productLine) {
      case 'Baking Cup':
        if (product.shape) {
          returnedDescription = `${returnedDescription} ${product.shape}`;
				}
        if (product.shape == 'Round') {
          if (product.size && product.size.BDIA && product.size.HEIGHT) {
            returnedDescription = `${returnedDescription} (B${product.size.BDIA}H${product.size.HEIGHT}mm)`;
          }
        } else {
          if (product.size && product.size.BWIDTH && product.size.BLENGTH && product.size.HEIGHT) {
            returnedDescription = `${returnedDescription} (B${product.size.BWIDTH}*${product.size.BLENGTH}H${product.size.HEIGHT}mm)`;
          }
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        break;

      case 'Cake Board':
        if (product.form) {
          returnedDescription = `${returnedDescription} ${product.form}`;
				}
        if (product.shape) {
          returnedDescription = `${returnedDescription} ${product.shape}`;
				}
        if (product.shape == 'Round') {
          if (product.size && product.size.DIA) {
            returnedDescription = `${returnedDescription} (${product.size.DIA}mm)`;
          }
        } else {
          if (product.size && product.size.WIDTH && product.size.LENGTH) {
            returnedDescription = `${returnedDescription} (${product.size.WIDTH}*${product.size.LENGTH}mm)`;
          }
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        break;

      case 'PSL':
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        if (product.size && product.size.WIDTH && product.size.REPEAT) {
          returnedDescription = `${returnedDescription} (${product.size.WIDTH}*${product.size.REPEAT}mm)`;
        }
        break;

      case 'Wet Wipes':
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        if (product.size && product.size.WIDTH && product.size.LENGTH) {
          returnedDescription = `${returnedDescription} (${product.size.WIDTH}*${product.size.LENGTH}mm)`;
        }
        if (_.get(product,'wetWipes.fragrance')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'wetWipes.fragrance')}`;
        }
        break;

      case 'Tray Cup':
        if (_.get(product, 'packingMode.0.quantity')) {
          returnedDescription = `${returnedDescription}, ${_.get(product, 'packingMode.0.quantity')} Pcs / Tray`;
        }
        if (product.size && product.size.BDIA && product.size.HEIGHT) {
          returnedDescription = `${returnedDescription}, B${product.size.BDIA} H${product.size.HEIGHT} mm`;
        }
        break;

      case 'Tray':
        if (product.shape) {
          returnedDescription = `${returnedDescription} ${product.shape}`;
				}
        if (product.shape == 'Round') {
          if (product.size && product.size.DIA) {
            returnedDescription = `${returnedDescription} (${product.size.DIA}mm)`;
          }
        } else {
          if (product.size && product.size.WIDTH && product.size.LENGTH) {
            returnedDescription = `${returnedDescription} (${product.size.WIDTH}*${product.size.LENGTH}mm)`;
          }
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        break;

      case 'Cake Box':
        if (product.size && product.size.BWIDTH && product.size.BLENGTH && product.size.HEIGHT) {
          returnedDescription = `${returnedDescription}  (B${product.size.BWIDTH}*${product.size.BLENGTH}H${product.size.HEIGHT}mm)`;
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        break;

      case 'Doilies':
        if (product.shape) {
          returnedDescription = `${returnedDescription} ${product.shape}`;
				}
        if (product.shape == 'Round') {
          if (product.size && product.size.DIA) {
            returnedDescription = `${returnedDescription}  (${product.size.DIA}mm)`;
          }
        } else {
          if (product.size && product.size.WIDTH && product.size.LENGTH) {
            returnedDescription = `${returnedDescription} (${product.size.LENGTH}*${product.size.WIDTH}mm)`;
          }
        }
        break;

      case 'Wrap Paper':
        if (product.form) {
          returnedDescription = `${returnedDescription} ${product.form}`;
				}
        if (product.form === 'Sheet') {
          if (product.shape)
            returnedDescription = `${returnedDescription} ${product.shape}`;
          if (product.shape == 'Round') {
            if (product.size && product.size.DIAMETER) {
              returnedDescription = `${returnedDescription} (D${product.size.DIAMETER}mm)`;
            }
          } else {
            if (product.size && product.size.WIDTH && product.size.LENGTH) {
              returnedDescription = `${returnedDescription} (${product.size.WIDTH}*${product.size.LENGTH}mm)`;
            }
          }
        } else {
          if (product.size && product.size.LENGTH && product.size.WIDTH) {
            returnedDescription = `${returnedDescription} W${product.size.WIDTH}mm L${product.size.LENGTH}m`;
          }
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        break;

      case 'Tulip Cup':
        if (product.familyName) {
          returnedDescription = `${returnedDescription} ${product.familyName}`;
        }
        if (product.shape) {
          returnedDescription = `${returnedDescription} ${product.shape}`;
				}
        if (product.size && product.size.BDIA && product.size.LENGTH) {
          returnedDescription = `${returnedDescription}  (B${product.size.BDIA}D${product.size.LENGTH}mm)`;
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription}, ${_.get(
            product,
            'printing.design.0.designName'
          )}`;
        }
        break;

      case 'Baking Mold':
        if (product.familyName) {
          returnedDescription = `${returnedDescription} ${product.familyName}`;
        }
        if (product.shape) {
          returnedDescription = `${returnedDescription} ${product.shape}`;
				}
        if (product.shape == 'Round') {
          if (product.size && product.size.BDIA && product.size.HEIGHT) {
            returnedDescription = `${returnedDescription} (B${product.size.BDIA}*H${product.size.HEIGHT}mm)`;
          }
        } else {
					if (product.size && product.size.BWIDTH && product.size.BLENGTH && product.size.HEIGHT) {
            returnedDescription = `${returnedDescription} (B${product.size.BWIDTH}*${product.size.BLENGTH}*H${product.size.HEIGHT}mm)`;
          }
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        break;

      case 'Cup Cover':
        if (product.size && product.size.BDIA && product.size.HEIGHT) {
          returnedDescription = `${returnedDescription} (B${product.size.BDIA}*H${product.size.HEIGHT}mm)`;
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        break;

      case 'Coaster':
        if (product.size && product.size.DIA) {
          returnedDescription = `${returnedDescription} (${product.size.DIA}mm)`;
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        break;

      case 'Corrugated Paper':
        if (product.form) {
          returnedDescription = `${returnedDescription} ${product.form}`;
				}
        if (product.form === 'Sheet') {
          if (product.shape)
            returnedDescription = `${returnedDescription} ${product.shape}`;
          if (product.shape == 'Round') {
            if (product.size && product.size.DIAMETER) {
              returnedDescription = `${returnedDescription} (D${product.size.DIAMETER}mm)`;
            }
          } else if (product.shape == 'U Tray') {
						if (product.size && product.size.LENGTH && product.size.WIDTH && product.size.HEIGHT) {
              returnedDescription = `${returnedDescription} (${product.size.WIDTH}*${product.size.LENGTH})*${product.size.HEIGHT}mm`;
            }
          } else {
            if (product.size && product.size.WIDTH && product.size.LENGTH) {
              returnedDescription = `${returnedDescription} (${product.size.WIDTH}*${product.size.LENGTH}mm)`;
            }
          }
        } else {
          if (product.size && product.size.LENGTH && product.size.WIDTH) {
            returnedDescription = `${returnedDescription} W${product.size.WIDTH}mm L${product.size.LENGTH*1000}m`;
          }
        }
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        break;

      case 'Ribbon':
        if (product.baseMaterial) {
          returnedDescription = `${returnedDescription} ${product.baseMaterial.MTLCOL}`;
        }
        if (product.size && product.size.WIDTH && product.size.LENGTH) {
          returnedDescription = `${returnedDescription} L${product.size.LENGTH} W${product.size.WIDTH}`;
        }
        break;

      case 'Coffee Filter':
        if (product.size && product.size.BDIA && product.size.HEIGHT) {
          returnedDescription = `${returnedDescription} (B${product.size.BDIA}H${product.size.HEIGHT}mm)`;
        }
        break;

      case 'Coffee Cup Sleeve':
        if (_.get(product, 'printing.design.0.designName')) {
          returnedDescription = `${returnedDescription} ${_.get(product,'printing.design.0.designName')}`;
        }
        if (product.size && product.size.WIDTH && product.size.LENGTH) {
          returnedDescription = `${returnedDescription} (${product.size.WIDTH}*${product.size.LENGTH}mm)`;
        }
        break;

      default:
        returnedDescription = 'no-category-name';
        break;
    }
    return returnedDescription;
  }
  return product ? product._id : '';
}